// removed by extract-text-webpack-plugin
module.exports = {"Content":"home__Content__1x4oj","fadeInLoad":"home__fadeInLoad__1K2ry","Selfie":"home__Selfie__3ZXUz","Clearfix":"home__Clearfix__2OGUz"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/home.css
// module id = 62
// module chunks = 0